import axios from 'axios';
import store from '@/store';
import router from '@/router';
import loadingProgress from '@/classes/LoadingProgress';
import Upload from '@/classes/Upload';
import _ from 'underscore';

const instance = axios.create({
    baseURL: `/api/v1/`,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

instance.interceptors.request.use((config) => {
    loadingProgress.start();
    return config;
}, (err) => {
    loadingProgress.stop();
    return Promise.reject(err);
});

instance.interceptors.response.use((response)  => {

    loadingProgress.stop();

    if (response.status === 202) {
        router.push('/resetpassword');
    }

    return response;

}, (err) => {

    loadingProgress.stop();

    if (err.response.status === 401) {
        store.commit('setActiveProfile', undefined);
        router.push('/login');
    }

    return Promise.reject(err);
});

export function upload<T extends Upload>(url: string, f: T) {

    const data = _.reduce(f, (d, v, k) => {
        d.append(k, v);
        return d;
    }, new FormData());

    return instance.post(url, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export const api = () => instance;
export default () => instance;
